import r from"styled-components";import{theme as o}from"../../../../../theme.js";const n=r.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${o.spacing*2}px;
  width: 100%;
`,i=r.div`
  width: 100%;
  box-sizing: border-box;
  padding: ${o.spacing*4}px;
  border-radius: ${o.radius}px;
  box-shadow: ${o.boxShadow};
  display: flex;
  flex-direction: column;
  gap: ${o.spacing*4}px;
  > img {
    aspect-ratio: 16/9;
    object-fit: cover;
    width: 100%;
    border-radius: ${o.radius}px;
  }
`,t=r.button`
  background-color: ${({selected:e})=>e?o.colors.gray[300]:o.colors.gray[200]};
  /* background-color: ${o.colors.gray[200]}; */
  color: ${o.colors.gray[600]};
  border-radius: ${o.radius}px;
  border: none;
  outline: none;
  width: 100%;
  line-height: 24px;
  font-size: 14px;
  padding: ${o.spacing*3}px ${o.spacing*6}px;
  cursor: pointer;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  &:hover, &:active {
    background-color: #CBD5E1;
    color: ${o.colors.gray[600]};
  }
  > span {
    font-size: 12px;
  }
`,s=r.span`
  font-size: 20px;
  font-weight: 700;
  color: ${o.colors.gray[900]};
`,a=r.span`
  align-self: flex-end;
  font-size: 14px;
  color: ${o.colors.gray[800]};
`,l=r.span`
  font-size: 16px;
  color: ${o.colors.gray[600]};
  line-height: 21px;
`,c=r.button`
  outline: none;
  border: none;
  align-self: flex-end;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  background-color: unset;
  cursor: pointer;
  color: ${o.colors.primary[500]};
`;export{t as AnswerButton,n as Container,i as PollContainer,s as PollQuestion,l as PostVotingMessage,c as ReadMore,a as TotalVotes};
